/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React from "react";
import { useEffect, useState } from "react";
import "../css/floatingsidenav.css"

const FloatingSideNav = ({ items }) => {
  const [active, setActive] = useState("");
  const [topLimit, setTopLimit] = useState(0);
  const [bottomLimit, setBottomLimit] = useState(0);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const header = document.getElementById("header");
    const footer = document.getElementById("footer");

    if (header && footer) {
      setTopLimit(header.offsetHeight + 50); // Position below the header
      setBottomLimit(footer.offsetTop - 450); // Stop before footer
    }

    const handleScroll = () => {
      let current = "";
      items.forEach(({ href }) => {
        const section = document.getElementById(href.substring(1));
        if (section) {
          const sectionTop = section.offsetTop - 50;
          if (window.scrollY >= sectionTop) {
            current = href;
          }
        }
      });
      setActive(current);

      // Stick to top limit
      if (window.scrollY + 100 > topLimit && window.scrollY + 200 < bottomLimit) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [items, topLimit, bottomLimit]);

  return (
    <div className={`floating-nav ${isFixed ? "fixed" : ""}`} style={{ top: topLimit }}>
      <ul>
        {items.map(({ text, href }) => (
          <li key={href}>
            <a href={href} className={active === href ? "active" : ""}>
              {text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default FloatingSideNav;
